import { createAsyncThunk } from '@reduxjs/toolkit';

import { TaxStatementService } from 'api';

export const getTaxStatements = createAsyncThunk(
	'statement/getTaxStatements',
	async (params?: any) => {
		return await TaxStatementService.getAll(params);
	},
);
